export const MACHINES = {
    EFFICIENCY_TYPE: {
        OFFSET_PRINT: 1,
        DIGITAL_SHEET: 2,
        CUTTING_FROM_ROLL: 3,
        BILLBOARD_COLLECTOR: 4,
        LAMINATION: 5,
        TINNING: 6,
        LITHO_LAMINATION: 7,
        PUNCHING: 8,
        DRILLING: 9,
        CALENDAR_ASSEMBLY: 10,
        STACK_DIE_CUTTING: 11,
        SPIRAL: 12
    },
    WASTE_TYPE: {
        FOLDING: 1,
        PERCENT_WASTE: 2,
        AMOUNT_WASTE: 3,
        COLOUR: 4
    },
    NUMBER_OF_WORKERS_MAX_COUNT: 9,
    COST_CENTER_NUMBERS_LIMIT: 10000,
    CONFIGURATION_PARAMETERS: {
        PRODUCTION_PROCESS: 'productionProcess'
    }
} as const
